import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { RouterStateSerializer } from '@ngrx/router-store';

import { RouterStateUrlInterface } from 'app/core/browser/state/models/router-state-url.interface';

// https://github.com/ngrx/platform/blob/master/docs/router-store/api.md#custom-router-state-serializer
export class RouterStateUrlSerializer implements RouterStateSerializer<RouterStateUrlInterface> {
  /**
   * serialize
   *
   * Serializes the RouterStateSnapshot object into a simpler representation for the router store
   *
   * @param routerState The router state object managed by Angular
   *
   * @returns A light-weight object with basic router state information
  */
  public serialize(routerState: RouterStateSnapshot): RouterStateUrlInterface {
    let route: ActivatedRouteSnapshot = routerState.root;

    while (route.firstChild) {
      route = route.firstChild;
    }

    const { url, root: { queryParams } }: RouterStateSnapshot = routerState;
    const { params }: ActivatedRouteSnapshot = route;

    return { url, params, queryParams };
  }
}
